module.exports = __webpack_public_path__ + "img/1.1fbac9c1.png";